function ExceptionUserExist() {
    const error = new Error();
    error.code = 422;

    return error;
}

ExceptionUserExist.prototype = Object.create(Error.prototype);

export default ExceptionUserExist;
